const gameEditFields = [
  { name: 'name', label: 'Game Title', type: 'text', required: true, gridProps: { xs: 12 } },
  { name: 'platform', label: 'Platform', type: 'text', required: true, gridProps: { xs: 12, sm: 6 } },
  { name: 'releaseYear', label: 'Release Year', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'genre', label: 'Genre', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'developer', label: 'Developer', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'publisher', label: 'Publisher', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'region', label: 'Region', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  {
    name: 'priority', label: 'Priority', type: 'select',
    options: ['Low', 'Medium', 'High'], required: false, gridProps: { xs: 12, sm: 6 }
  },
  { name: 'played', label: 'Played', type: 'checkbox', required: false, gridProps: { xs: 6 } },
  { name: 'completed', label: 'Completed', type: 'checkbox', required: false, gridProps: { xs: 6 } },
  {
    name: 'condition', label: 'Condition', type: 'select', required: false, gridProps: { xs: 12, sm: 6 },
    options: [
      'Brand New (BNIB / NIB)', 'New Old Stock (NOS)', 'Factory Sealed', 'Mint Condition (MINT)',
      'Like New', 'Complete in Box (CIB)', 'Box Only / Case Only', 'Manual Only',
      'Disc/Cartridge Only (Loose)', 'Tested & Working', 'Good / Acceptable',
      'Damaged Label / Writing', 'Resurfaced Disc', 'Repro / Reproduction', 'For Parts / Not Working',
    ]
  },
  {
    name: 'edition', label: 'Edition', type: 'select', required: false, gridProps: { xs: 12, sm: 6 },
    options: ['Not Specified', 'Standard', "Collector's", 'Limited', 'Steelbook', 'Digital']
  },
  { name: 'imageUrl', label: 'Image URL', type: 'text', required: false, gridProps: { xs: 12 } },
  { name: '_igdbLookup', type: 'igdb-lookup', gridProps: { xs: 12 } },
  { name: 'rating', label: 'Rating', type: 'rating', required: false, gridProps: { xs: 12 } },
  { name: 'notes', label: 'Notes', type: 'text', multiline: true, rows: 4, required: false, gridProps: { xs: 12 } },
];

export default gameEditFields;
